/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type BookingListElementBookingFragment = { guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason: Types.BookingCancelReason | null, summary: string | null, assignedStaff: { displayName: string } };

export const BookingListElementBookingFragmentDoc = gql`
    fragment BookingListElementBooking on Booking {
  guid
  startsAt
  endsAt
  cancelReason
  summary
  assignedStaff {
    displayName
  }
}
    `;